export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || ''
